/* eslint-disable @next/next/no-img-element */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import Paper from '@base/Paper/Paper';
import Button from '@base/Button/Button';
import { getImage } from '@utils/imageHelper';
import { Spacings } from '@styles/index';

const ActivateWrapper = styled(Paper)`
  grid-column: span 18;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${Spacings.SPACING_10B} ${Spacings.SPACING_8B};
  position: relative;
`;

const FirstBlock = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  img {
    height: 40px;
    width: 40px;
    margin-right: ${Spacings.SPACING_6B};
  }
`;

const StaticImage = styled.img`
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 80px;
  width: 80px;
  display: none;
`;

const StyledH4 = styled(H4)`
  color: var(--color-text-primary);
`;

const ActivateSubscription = ({ feedBlock, openExternalAppActivation }) => {
  const externalAppActivation = (externalApp) => {
    if (externalApp?.external_app.display_name === 'PrepLadder') {
      openExternalAppActivation(externalApp);
    } else {
      window.location.href = externalApp.activation_url;
    }
  };

  const isBrowseBlock =
    feedBlock.type === 'external_subscription_postactivation';
  const externalApp = feedBlock.extraBlockinfo;
  const isCodeChef =
    externalApp?.external_app?.display_name?.toLowerCase() === 'codechef';

  const beforeActivationText = isCodeChef ? 'Sync now' : 'Activate now';

  return (
    <ActivateWrapper>
      <FirstBlock>
        <img src={feedBlock.extraBlockinfo.external_app.icon} alt="logo" />
        <div>
          {!externalApp?.message ? (
            <P1 color="var(--color-text-secondary)">ICONIC subscription</P1>
          ) : null}
          <StyledH4>
            {externalApp?.message
              ? externalApp.message
              : `Activate your ${feedBlock.extraBlockinfo.external_app.display_name} subscription`}
          </StyledH4>
        </div>
      </FirstBlock>
      <Button
        label={isBrowseBlock ? 'Browse' : beforeActivationText}
        grid={4}
        onClick={
          isBrowseBlock
            ? () => window.open(externalApp?.external_app.web_url)
            : () => externalAppActivation(externalApp)
        }
        dataAnalytics="goal-activateNow"
      />
      <StaticImage src={getImage('checkout/activation-edge.png')} alt="img" />
    </ActivateWrapper>
  );
};

export default ActivateSubscription;

ActivateSubscription.propTypes = {
  feedBlock: PropTypes.objectOf(PropTypes.any).isRequired,
  openExternalAppActivation: PropTypes.func.isRequired
};
